import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import { PolicyContextProvider } from '../PolicyContainer';

import GLFnol from './GLFnol';
import GLFnolSearchScreen from './GLFnolSearchScreen';

function GLFnolContainer(props) {
  const history = useHistory();
  const { organization } = props;
  const [searchValues, setSearchValues] = useState(undefined);

  if (!searchValues) {
    return <GLFnolSearchScreen onReportNewFnol={setSearchValues} />;
  } else {
    return (
      <PolicyContextProvider
        policy={{ type: 'gl_policy', lob: 'gl_policy', contacts: [], organization_id: organization.id }}
      >
        {' '}
        {/* actual policy is fetched later based on property */}
        <GLFnol
          organization={organization}
          searchValues={searchValues}
          onSubmit={(claimId) => history.push(`/claims/${claimId}`)}
        />
      </PolicyContextProvider>
    );
  }
}

GLFnolContainer.propTypes = {
  organization: PropTypes.object.isRequired,
};

export default GLFnolContainer;
